<template>
  <div>
    <h1 class="mb-4 text-2xl font-bold">Edit Profil Jurusan</h1>
    <form @submit.prevent="submit">
      <div class="mb-4">
        <label class="block">Visi</label>
        <textarea v-model="form.visi" class="w-full input" required></textarea>
      </div>
      <div class="mb-4">
        <label class="block">Misi</label>
        <textarea v-model="form.misi" class="w-full input" required></textarea>
      </div>
      <div class="mb-4">
        <label class="block">Akreditasi</label>
        <input v-model="form.akreditasi" class="w-full input" required />
      </div>
      <button type="submit" class="btn btn-primary">Update</button>
      <Link :href="route('profil-jurusan.index')" class="ml-2 btn"
        >Kembali</Link
      >
    </form>
  </div>
</template>

<script setup>
import { Link, useForm } from "@inertiajs/vue3";
const props = defineProps({ profil_jurusan: Object });
const form = useForm({
  visi: props.profil_jurusan.visi,
  misi: props.profil_jurusan.misi,
  akreditasi: props.profil_jurusan.akreditasi,
});
function submit() {
  form.put(route("profil-jurusan.update", props.profil_jurusan.id));
}
</script>
